import { useTranslation } from 'react-i18next';
import { Badge, type BadgeProps } from '@/components/ui/badge';
import { ITEM_TYPE_LABEL_KEY, type ItemType } from '@/lib/itemTypeConfig';

const toneByType: Record<ItemType, NonNullable<BadgeProps['tone']>> = {
  medication: 'medication',
  consumable: 'consumable',
  medical_device: 'medical-device',
  reagent: 'reagent',
  other: 'other',
};

interface TypePillProps {
  type: ItemType;
  size?: BadgeProps['size'];
  className?: string;
}

export function TypePill({ type, size, className }: TypePillProps) {
  const { t } = useTranslation();
  return (
    <Badge tone={toneByType[type]} size={size} className={className}>
      {t(ITEM_TYPE_LABEL_KEY[type])}
    </Badge>
  );
}
